import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { renderReviewValue } from "@/lib/createShop/reviewValue";
import type { CreateShopReviewGroupProps } from "./CreateShopReviewGroup.types";
import * as styles from "./CreateShopReviewGroup.styles";

export function CreateShopReviewGroup({ group }: CreateShopReviewGroupProps) {
  const { t } = useTranslation(["shops", "settings"]);

  return (
    <Box sx={styles.root}>
      <Box sx={styles.header}>
        <Typography sx={styles.title}>{t(group.title)}</Typography>
        <Typography sx={styles.edit} onClick={group.onEdit}>
          {t("create.review.edit")}
        </Typography>
      </Box>

      {group.rows.map((row) => (
        <Box key={`${group.title}-${row.key}`} sx={styles.row}>
          <Typography sx={styles.key}>{t(row.key)}</Typography>
          <Typography sx={styles.value}>{renderReviewValue(row, t)}</Typography>
        </Box>
      ))}
    </Box>
  );
}
